  import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,downloadExcelReports} from '../../services/index';
import { Collapse,Popconfirm, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message,Select,Modal   } from 'antd';
import {  EditOutlined,SafetyCertificateOutlined,DeleteOutlined,DownloadOutlined,WhatsAppOutlined,MailOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";
import FilterTable from "../../component/student_fees_filter_table";

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}
const { Option } = Select;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			email_visible: false,
			email_subject: '',
			email_body: '',
			value: '',
			checkedBoxes: [],
			permission: [],
			school_list: [],
			program_list: [],
			academic_year_: [],
			template_list: [],
			division_list: [],
			total_self: 0,
			total_franchise: 0,
			is_show: 0,
			aToken: '',
			main_menu: '',
			division: '',
			sub_menu: '',
			academic_year: '',
			student_type: '',
			name: '',
			is_transport: '',
			total_count:0,
			program_id:'',
			page: 1,
			perPage: 10,
			docx_loading:false,
			docx_excel:'Document Reports',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
				});
			}, 50);
			
		}
		
		setTimeout(() => {
			this.checkData();
		}, 100);
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,id: this.props.match.params.id}
			getData('report/children_fees_report_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							name: result['data'][0]['name'],
							is_show: 1,
						});
					}else{
						this.setState({
							school_list: [],
							is_show: 1,
						});
					}
				}
			});
	}
    }
	
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	
  

	render()

	{
	const {aToken}=this.state;
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<>
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i>{this.state.name}
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> 
											<a href={`${process.env.PUBLIC_URL}/reports/children-fees-report`}>Child Fees Report </a></li>
											<li class="breadcrumb-item"> Child Fees Report Details</li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 form-group">
					 <div class="card">
						<div class="card-body">
						<div class="row">
						<div class="col-sm-10 col-12 text-right  enquiry-btn mt-5px">
							
						</div>
						</div>
						
                        <div class="table-responsive new-table">
                            <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
									
                                    <th>#</th>
                                    <th>Fees</th>
									<th>Amount</th>
									<th>Paid</th>
									<th>Pending</th>
									<th>Due Date</th>
                                 </tr>
                              </thead>
                              <tbody>
							   {(this.state.school_list.length == 0 && this.state.is_show == 1 ) && (<><tr><td colspan="12" class="text-center">No Report Found</td></tr></>)}
							  {(this.state.school_list.length == 0 && this.state.is_show == 0 ) && (<><tr><td colspan="12" class="text-center">Please Wait While Loading</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
								<>
                                 <tr>
									<td>1</td>
									<td>Admission Fee</td>
									<td>{list.admission_fee}</td>
									<td>{list.admission_fee_paid}
									</td>
									<td>{list.admission_fee_pending}</td>
									<td>-</td>
								</tr>
                                 <tr>
									<td>2</td>
									<td>Admission Form</td>
									<td>{list.admission_form}</td>
									<td>{list.admission_form_paid}<br/>
									<b>{list.admission_form_id}</b></td>
									<td>{list.admission_form_pending}</td>
									<td>-</td>
								</tr>
                                 <tr>
									<td>3</td>
									<td>Caution deposit</td>
									<td>{list.deposit}</td>
									<td>{list.deposit_paid}<br/>
									<b>{list.deposit_id}</b></td>
									<td>{list.deposit_pending}</td>
									<td>-</td>
								</tr>
                                 <tr>
									<td>4</td>
									<td>Starter Kit/Books</td>
									<td>{list.starter_kit}</td>
									<td>{list.starter_kit_paid}<br/>
									<b>{list.starter_kit_id}</b></td>
									<td>{list.starter_kit_pending}</td>
									<td>-</td>
								</tr>
                                 <tr>
									<td>5</td>
									<td>Uniform</td>
									<td>{list.uniform}</td>
									<td>{list.uniform_paid}<br/>
									<b>{list.uniform_id}</b></td>
									<td>{list.uniform_pending}</td>
									<td>-</td>
								</tr>
                                 <tr>
									<td>6</td>
									<td>Activity Fee</td>
									<td>{list.activity_fee}</td>
									<td>{list.activity_fee_paid}<br/>
									<b>{list.activity_fee_id}</b></td>
									<td>{list.activity_fee_pending}</td>
									<td>-</td>
								</tr>
                                 <tr>
									<td>7</td>
									<td>Tuition Fee 1</td>
									<td>{list.confirmation_fee}</td>
									<td>{list.confirmation_fee_paid}<br/>
									<b>{list.confirmation_fee_id}</b></td>
									<td>{list.confirmation_fee_pending}</td>
									<td>{list.tuition_fee_1_date}</td>
								</tr>
                                 <tr>
									<td>8</td>
									<td>Tuition Fee 2</td>
									<td>{list.tuition_fee_1}</td>
									<td>{list.tuition_fee_1_paid}<br/>
									<b>{list.tuition_fee_1_id}</b></td>
									<td>{list.tuition_fee_1_pending}</td>
									<td>{list.tuition_fee_2_date}</td>
								</tr>
                                 <tr>
									<td>9</td>
									<td>Tuition Fee 3</td>
									<td>{list.tuition_fee_2}</td>
									<td>{list.tuition_fee_2_paid}<br/>
									<b>{list.tuition_fee_2_id}</b></td>
									<td>{list.tuition_fee_2_pending}</td>
									<td>{list.tuition_fee_3_date}</td>
								</tr>
                                 <tr>
									<td>10</td>
									<td>Tuition Fee 4</td>
									<td>{list.tuition_fee_3}</td>
									<td>{list.tuition_fee_3_paid}<br/>
									<b>{list.tuition_fee_3_id}</b></td>
									<td>{list.tuition_fee_3_pending}</td>
									<td>{list.tuition_fee_4_date}</td>
								</tr>
                                 <tr>
									<td>11</td>
									<td>Transport Term 1</td>
									<td>{list.transport_term_1}</td>
									<td>{list.transport_term_1_paid}<br/>
									<b>{list.transport_term_1_id}</b></td>
									<td>{list.transport_term_1_pending}</td>
									<td>{list.transport_term_1_date}</td>
								</tr>
                                 <tr>
									<td>12</td>
									<td>Transport Term 2</td>
									<td>{list.transport_term_2}</td>
									<td>{list.transport_term_2_paid}<br/>
									<b>{list.transport_term_2_id}</b></td>
									<td>{list.transport_term_2_pending}</td>
									<td>{list.transport_term_2_date}</td>
								</tr>
                                 <tr>
									<td></td>
									<td><b>Total</b></td>
									<td><b>{list.total_fees}</b></td>
									<td><b>{list.total_paid}</b></td>
									<td><b>{list.pending_fees}</b></td>
									<td>-</td>
								</tr>
								</>
								 ))}
                                
                              </tbody>
                           </table>
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
